import { LyMenuTriggerFor, LyTemplateMenu } from './menu';
import { LyMenu } from './menu';
import { ThemeModule, LxDomModule } from 'alyle-ui/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
var LyMenuModule = /** @class */ (function () {
    function LyMenuModule() {
    }
    LyMenuModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, FormsModule, ThemeModule, LxDomModule],
                    exports: [LyMenu, LyMenuTriggerFor],
                    declarations: [LyMenu, LyMenuTriggerFor, LyTemplateMenu],
                },] },
    ];
    /** @nocollapse */
    LyMenuModule.ctorParameters = function () { return []; };
    return LyMenuModule;
}());
export { LyMenuModule };
//# sourceMappingURL=menu.module.js.map